let navigate;

export const setNavigate = (navigateFn) => {
    navigate = navigateFn;
};

export const getNavigate = () => navigate;
